export default __webpack_public_path__ + "static/media/logo-size-111px-colour=ec0f69.b2ec63d7.svg";